module.exports = __webpack_public_path__ + "75bf4a2a07d2b98aba8b8cb625bc33.png";